import { UseUserSettingsInterface } from 'modules/profile/user-settings/types/user-settings-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const USER_SETTINGS_API = '/api/dashboard/settings/profile'

export function useUserSettings() {
  const { user, isWorkspaceOwner } = useUser()

  const { fetcher } = useFetch<RequestMethodsEnum.get, UseUserSettingsInterface>({
    method: RequestMethodsEnum.get,
  })
  const { data: userSettings, mutate } = useControlledSwr(
    () => USER_SETTINGS_API,
    fetcher,
    undefined,
    !!user && isWorkspaceOwner,
  )
  return { userSettings, mutate }
}
